module.exports = __webpack_public_path__ + "static/media/gallery12.a99f7110.jpeg";